import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// import type { TFunction } from 'i18next';
import * as Sentry from '@sentry/react';

import { ErrorLanding } from './ErrorLanding';

// Feedback dialog is temporarily disabled — for now we only report the error.
// To re-enable: uncomment promptCrashReport below, its call in AppErrorFallback,
// and the TFunction import. Keys already exist under errorPage.feedback.*.
// function promptCrashReport(eventId: string, t: TFunction) {
//   // Guarded on getClient() — Sentry isn't initialized in local dev (see main.tsx),
//   // and showReportDialog would otherwise warn/no-op.
//   if (!Sentry.getClient()) return;
//
//   Sentry.showReportDialog({
//     eventId,
//     title: t('errorPage.feedback.title'),
//     subtitle: t('errorPage.feedback.subtitle'),
//     subtitle2: t('errorPage.feedback.subtitle2'),
//     labelName: t('errorPage.feedback.labelName'),
//     labelEmail: t('errorPage.feedback.labelEmail'),
//     labelComments: t('errorPage.feedback.labelComments'),
//     labelSubmit: t('errorPage.feedback.labelSubmit'),
//     successMessage: t('errorPage.feedback.successMessage'),
//   });
// }

// Shared fallback UI for uncaught render errors. Used by both the top-level
// Sentry.ErrorBoundary and the router's defaultErrorComponent (RouteErrorComponent).
function AppErrorFallback({ eventId }: { eventId?: string }) {
  const { t } = useTranslation();

  useEffect(() => {
    // Feedback dialog disabled for now — see promptCrashReport above.
    // if (eventId) promptCrashReport(eventId, t);
  }, [eventId, t]);

  return (
    <ErrorLanding
      heading={t('errorPage.unexpected.heading')}
      subHeading={t('errorPage.unexpected.subheading')}
      description={t('errorPage.unexpected.description')}
      footer={t('errorPage.unexpected.footer')}
    />
  );
}

// TanStack Router catches route-render errors into its own boundary instead of
// letting them bubble to a React error boundary, so those crashes never reach
// Sentry.ErrorBoundary. Capture here (for visibility, e.g. Base UI crashes on
// older Safari) and hand the eventId to the fallback.
export function RouteErrorComponent({ error }: { error: unknown }) {
  const [eventId, setEventId] = useState<string>();

  useEffect(() => {
    setEventId(Sentry.captureException(error));
  }, [error]);

  return <AppErrorFallback eventId={eventId} />;
}

export default AppErrorFallback;
